import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {useStableRandom} from '@github-ui/use-stable-random'
import {clsx} from 'clsx'

import styles from './ConversationLoader.module.css'

export function ConversationLoader() {
  const lineCount = useStableRandom({max: 4}) + 2
  return (
    <div className={styles.ConversationLoader} data-testid="conversation-loader">
      <div className={styles.ConversationLoader__userGroup}>
        <LoadingSkeleton variant="rounded" height="20px" width="random" />
      </div>
      <div className={styles.ConversationLoader__assistantGroup}>
        <LoadingSkeleton
          className={clsx(styles.ConversationLoader__assistantAvatar, styles.assistantAvatarSkeleton)}
          variant="elliptical"
        />
        {Array.from({length: lineCount}).map((_, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <LoadingSkeleton variant="rounded" height="20px" width="random" key={index} />
        ))}
      </div>
    </div>
  )
}
